import { z } from "zod";

const MIN_AMOUNT = 1000;
const MAX_AMOUNT = 100000;
const MIN_AMOUNT_MESSAGE = `Сумма не может быть меньше ${MIN_AMOUNT} ₽`;
const MAX_AMOUNT_MESSAGE = `Сумма не может быть больше ${MAX_AMOUNT} ₽`;

export const topUpSchema = z.object({
  amount: z
    .string()
    .trim()
    .min(1, "Введите сумму")
    .refine((val) => !isNaN(Number(val)) && Number(val) >= MIN_AMOUNT, {
      message: MIN_AMOUNT_MESSAGE,
    })
    .refine((val) => !isNaN(Number(val)) && Number(val) <= MAX_AMOUNT, {
      message: MAX_AMOUNT_MESSAGE,
    }),
  email: z
    .string()
    .trim()
    .min(1, "Введите email для чека")
    .email("Введите корректный email"),
  promo: z.string().optional(),
});

export type TopUpFormValues = z.infer<typeof topUpSchema>;
